module.exports = __webpack_public_path__ + "img/ad2.128dac17.png";